import { memo } from "react";
import { ReactSVG } from "react-svg";
import { Errors } from "services/forms/validation/types";
import { useHandleDateChange, useHandleDropdownChange } from "services/forms/hooks";
import WarehouseDropdown from "ui/components/Dropdown/WarehouseDropdown/WarehouseDropdown";
import { DatePicker } from "ui/components/DatePicker";
import { FleetTireSetEditFormValues } from "services/api/fleet/tires/types";
import { RelocateFormValues } from "../types";

interface RelocateStep1Props {
  currentSet: FleetTireSetEditFormValues;
  formValues: RelocateFormValues;
  setFormValues: React.Dispatch<React.SetStateAction<RelocateFormValues>>;
  errors: Errors;
}

const RelocateStep1: React.FC<RelocateStep1Props> = ({ currentSet, formValues, setFormValues, errors }) => {
  const handleDateChange = useHandleDateChange(setFormValues, formValues);
  const handleDropdownChange = useHandleDropdownChange(setFormValues, formValues);

  return (
    <div className="flex items-center justify-center px-4 min-h-[70vh] xl:min-h-[1000px]">
      <div className="w-full max-w-2xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1 mb-2">Premještaj seta guma</h1>
        <p className="text-center text-md text-slate-500 mb-8">
          Odaberite novo skladište za premještaj seta guma.
        </p>

        <div className="border bg-white border-slate-200">
          <div className="py-6 px-4">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-sm bg-slate-100 flex items-center justify-center flex-shrink-0">
                <ReactSVG src="/media/icons/warehouse.svg" className="w-5 h-5 stroke-slate-500" />
              </div>
              <div>
                <div className="text-sm font-semibold text-slate-900">Destinacija skladišta</div>
                <div className="text-xs text-slate-500">Odaberite skladište i datum premještaja</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <WarehouseDropdown
                  name="targetWarehouseId"
                  label="Skladište"
                  placeholder="Odaberite skladište..."
                  value={formValues.targetWarehouseId}
                  onChange={handleDropdownChange}
                  error={errors.targetWarehouseId}
                  excludeIds={currentSet.warehouse?.id ? [currentSet.warehouse.id] : []}
                  required
                />
              </div>
              <div>
                <DatePicker
                  name="transferDate"
                  label="Datum premještaja"
                  placeholder="Odaberite datum..."
                  onChange={handleDateChange}
                  error={errors.transferDate}
                  value={formValues.transferDate}
                  width="full"
                  required
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(RelocateStep1);
